import { createReducer, createSetter } from "@/redux/helpers/reducer";

import * as actions from "./first-time-user-experience.actions";

const initialState = {
  isOpen: false,
};

export default createReducer(initialState, {
  [actions.setIsOpen]: createSetter("isOpen"),

  [actions.reset]: () => ({ ...initialState }),
});
